"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageCarryable_sidecar_1 = require("@voyage/entities/voyageCarryable-sidecar");
var voyageJettisons_sidecar_1 = require("@voyage/entities/voyageJettisons-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.Jettison;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crewId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.carryableId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.x);
    messageWriter_sidecar_1.messageWriter.write32(m, d.y);
    messageWriter_sidecar_1.messageWriter.write32(m, d.dx);
    messageWriter_sidecar_1.messageWriter.write32(m, d.dy);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        crewId: messageWriter_sidecar_1.messageWriter.read32(m),
        carryableId: messageWriter_sidecar_1.messageWriter.read32(m),
        x: messageWriter_sidecar_1.messageWriter.read32(m),
        y: messageWriter_sidecar_1.messageWriter.read32(m),
        dx: messageWriter_sidecar_1.messageWriter.read32(m),
        dy: messageWriter_sidecar_1.messageWriter.read32(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        crewId: 100,
        carryableId: 345,
        x: 1231,
        y: 6548,
        dx: 1002,
        dy: 10,
    };
    messageWriter_sidecar_1.messageWriter.test('jettison', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    if (msg.carryableId > 0) {
        var cy = voyageCarryable_sidecar_1.voyageCarryable.findByIdSafe(msg.carryableId);
        if (!cy) {
            websockets_sidecar_1.websockets.reportBadCommand(m, msg, 'voyageMessage-jettison', 'carryable-id');
            return;
        }
        // console.log('jettison!', msg.x, msg.y, msg.dx, msg.dy)
        voyageJettisons_sidecar_1.voyageJettisons.create(null, cy, msg.x, msg.y, msg.dx, msg.dy);
        voyageCarryable_sidecar_1.voyageCarryable.kill(cy);
    }
}
exports.process = process;
function sendMessageAndImmediatelyExecute(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute(write, msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
